/**
 * Formats the given number as string and adds spaces as thousand separators.
 * Optionally, can format the number with decimals.
 * Eg. value 2020 becomes "2 020"
  * */
export var formatNumber = {
    id: "formatNumber",
    definition: function (value, decimals) {
        if (decimals === void 0) { decimals = 0; }
        if (!value)
            return value;
        var rex = /\B(?=(\d{3})+(?!\d))/g;
        if (decimals == 0) {
            return value.toString().replace(rex, " ");
        }
        else {
            var valueStr = value.toFixed(decimals);
            var parts = valueStr.split('.');
            var integerPart = parts[0].replace(rex, " ");
            var decimalPart = parts[1];
            return integerPart + "," + decimalPart;
        }
    }
};
